import React, { useState, useEffect } from 'react';
import {
    Box,
    Button
} from '@mui/material';

import AnalyticFilterBox from './AnalyticFilterBox';


const AnalyticFilterList = ({ initialAnalyticFilterOptions, initialAnalyticFilters, onChange }) => {
    const [analyticFilterOptions, setAnalyticFilterOptions] = useState([]); // Assuming data contains { fieldName: { additional_keys....} }
    const [analyticFilters, setAnalyticFilters] = useState<any[]>([]); // Assuming data contains { fieldName: { min: value, max: value } }

    useEffect(() => {
        if (analyticFilterOptions.length === 0) {
            console.log('Updating Analytic Filter Options')
            setAnalyticFilterOptions(initialAnalyticFilterOptions);
        }
        if (analyticFilters.keys.length === 0) {
            console.log('Updating Analytic Filters')
            setAnalyticFilters(initialAnalyticFilters);
        }
    }, []);

    const handleAnalyticAddFilterObj = () => {
        setAnalyticFilters([...analyticFilters, {}]);
        onChange('analytics', [...analyticFilters, {}]); // Add new filter obj
    };

    const handleAnalyticDeleteFilterObj = (index) => {
        const new_filter_list = [...analyticFilters.filter((_, i) => i !== index)]; // Delete the filter obj
        setAnalyticFilters(new_filter_list);
        onChange('analytics', new_filter_list); // Delete the filter obj
    };

    const handleFilterChange = (index, newAnalyticObj) => {
        console.log("New Analytic Obj:", newAnalyticObj);


        const updatedObjs = [...analyticFilters];

        console.log("Updated Objs:", updatedObjs);
        updatedObjs[index] = newAnalyticObj;

        onChange('analytics', updatedObjs);
    };

    return (
        <Box mb={2}>
            {analyticFilters.length > 0 && analyticFilters.map((_, index) => (
                <AnalyticFilterBox
                    key={index}
                    analyticsList={analyticFilterOptions}
                    openFilterValues={analyticFilters[index]}
                    onDelete={() => handleAnalyticDeleteFilterObj(index)}
                    onChange={(analyticObj) => handleFilterChange(index, analyticObj)}
                />
            ))}
            <Button onClick={handleAnalyticAddFilterObj} variant="contained" color="primary">
                Add Analytic Filter Object
            </Button>
        </Box>
    );
};

export default AnalyticFilterList;
